import React from "react";
import { useSettings } from "@/context/SettingsContext";
import { Facebook, Twitter, Instagram, Youtube, MessageCircle } from "lucide-react";

const ITEMS = [
  { key: "social_facebook", icon: Facebook, label: "Facebook" },
  { key: "social_twitter", icon: Twitter, label: "Twitter / X" },
  { key: "social_instagram", icon: Instagram, label: "Instagram" },
  { key: "social_youtube", icon: Youtube, label: "YouTube" },
  { key: "social_whatsapp", icon: MessageCircle, label: "WhatsApp" },
];

export default function SocialIcons({ variant = "header", className = "" }) {
  const { settings } = useSettings();
  if (!settings) return null;
  const enabled = ITEMS.filter((i) => settings[i.key]);
  if (!enabled.length) return null;

  const base =
    variant === "header"
      ? "w-8 h-8 grid place-items-center rounded-sm border border-border hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors"
      : "w-11 h-11 grid place-items-center rounded-sm border border-border hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors";

  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="social-icons">
      {enabled.map(({ key, icon: Icon, label }) => (
        <a
          key={key}
          href={settings[key]}
          target="_blank"
          rel="noreferrer"
          className={base}
          title={label}
          aria-label={label}
          data-testid={`social-icon-${key.replace("social_", "")}`}
        >
          <Icon className="w-4 h-4" />
        </a>
      ))}
    </div>
  );
}
